import { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { useCadaverService } from 'hooks/useCadaverService'

export const useEntregaCadaver = () => {
  const params = useParams()
  const cadaverService = useCadaverService()
  const [processando, setProcessando] = useState(false)
  const [cadaver, setCadaver] = useState({})

  useEffect(() => {
    if (params.id) {
      cadaverService.listarCadaver(params.id, setCadaver, setProcessando)
    }
  }, [params.id])

  return {
    cadaver,
    processando,
  }
}
